export const APPEARANCES = {
    H1: 'H1',
    H2: 'H2',
    H3: 'H3',
    H4: 'H4',
    H5: 'H5',
    H6: 'H6',
};
export const SIZE = {
    EXTRA_LARGE: 'extraLarge',
    LARGE: 'large',
    MEDIUM: 'medium',
    SMALL: 'small',
    TINY: 'tiny',
    EXTRA_TINY: 'extraTiny',
};
//# sourceMappingURL=Heading.constants.js.map